"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordFundReset = exports.recordFundLinkUnlinkReset = exports.fundUnlinkSingle = exports.fundUnlink = exports.fundSuccess = exports.fundList = exports.fundLinkSingle = exports.fundLink = exports.fundFind = exports.fundError = void 0;
var _fund = require("./fund.constant");
// @flow

// common success
var fundSuccess = function fundSuccess(actionType, data) {
  return {
    type: _fund.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.fundSuccess = fundSuccess;
var fundError = function fundError(actionType, error) {
  return {
    type: _fund.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fundFind
 * @param payload
 * @returns api response
 * @description this function used to find fund.
 */
exports.fundError = fundError;
var fundFind = function fundFind(data) {
  return {
    type: _fund.actionTypes.FIND,
    payload: data
  };
};

/**
 * fundList
 * @param payload
 * @returns api response
 * @description this function used to get fund list.
 */
exports.fundFind = fundFind;
var fundList = function fundList(data) {
  return {
    type: _fund.actionTypes.LIST,
    payload: data
  };
};

/**
 * fundLink
 * @param payload
 * @returns api response
 * @description this function used to link fund.
 */
exports.fundList = fundList;
var fundLink = function fundLink(data) {
  return {
    type: _fund.actionTypes.LINK,
    payload: data
  };
};

/**
 * fundLinkSingle
 * @param payload
 * @returns api response
 * @description this function used to link single fund.
 */
exports.fundLink = fundLink;
var fundLinkSingle = function fundLinkSingle(data) {
  return {
    type: _fund.actionTypes.LINK_SINGLE,
    payload: data
  };
};

/**
 * fundUnlink
 * @param payload
 * @returns api response
 * @description this function used to unlink fund.
 */
exports.fundLinkSingle = fundLinkSingle;
var fundUnlink = function fundUnlink(data) {
  return {
    type: _fund.actionTypes.UNLINK,
    payload: data
  };
};

/**
 * fundUnlinkSingle
 * @param payload
 * @returns api response
 * @description this function used to unlink single fund.
 */
exports.fundUnlink = fundUnlink;
var fundUnlinkSingle = function fundUnlinkSingle(data) {
  return {
    type: _fund.actionTypes.UNLINK_SINGLE,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.fundUnlinkSingle = fundUnlinkSingle;
var recordFundReset = function recordFundReset(data) {
  return {
    type: _fund.actionTypes.RESET,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.recordFundReset = recordFundReset;
var recordFundLinkUnlinkReset = function recordFundLinkUnlinkReset() {
  return {
    type: _fund.actionTypes.RESET_LINK_UNLINK
  };
};
exports.recordFundLinkUnlinkReset = recordFundLinkUnlinkReset;